import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import { createSelector } from 'reselect';

import { Urls, ModalTypes } from 'constants/constants';

import Link, { selectDeletedLinks, selectLinks } from 'store/models/Link';
import RouteState, { pushTo, linkEditUrl } from 'store/RouteState';
import UIState from 'store/UIState';

import { ContentCenter, Title, Header, HeaderLeft, HeaderRight, Breadcrumbs,  Section, SectionTitle } from 'components/Content';
import { LinkList, LinkManageList } from 'components/LinkItem';
import * as Icons from 'components/Svg';
import { NewButton } from 'components/Button';
import ScrollToTop from 'components/ScrollToTop';



// ======================
// STORE
// ======================
const selectors = createSelector(
  selectLinks,
  selectDeletedLinks,
  (links, deletedLinks) => Object.assign({ links, deletedLinks }),
);

// ======================
// COMPONENT
// ====================== 

const LinksScreen = ({match}) => {
  const { links, deletedLinks } = useSelector(s => selectors(s));
  const [loading, setLoading] = useState({
    links: false,
    deletedLinks: false,
  });
  const [showAll, setShowAll] = useState(false);
  const dispatch = useDispatch();

  const fetchData = async () => {
    let isLoading = _.mapValues(loading, () => true);
    setLoading(isLoading);

    await dispatch(Link.actions.fetchLinks())
    setLoading({..._.set(isLoading, 'links', false)});

    await dispatch(Link.actions.fetchDeletedLinks())
    setLoading({..._.set(isLoading, 'deletedLinks', false)});
  }

  useEffect(() => {
    (async () => {
      await fetchData();
    })();
  }, []);

  const onEditLink = linkId => dispatch(RouteState.actions.navigate(Urls.LINK_EDIT_ROUTE, { linkId }))
  const onNewLink = () => dispatch(RouteState.actions.navigate(Urls.LINK_NEW));
  const onDeleteLink2 = async linkId => dispatch(Link.actions.deleteLink(linkId));
  const onRestoreLink = async linkId => dispatch(Link.actions.restoreLink(linkId));

  const onDeleteLink = async (linkId) => {
    dispatch(UIState.actions.showModal(ModalTypes.CONFIRM, { 
      title: "Archive This Link?",
      subtitle: "This will remove the link from your Link Library, but your stats will remain",
      confirmText: "Yes, Archive It",
      onConfirm: async () => {
        dispatch(Link.actions.deleteLink(linkId));
      },
      onCancel: () => {}
    }));
  }

  return (<>
    <ScrollToTop />
    <ContentCenter className="links">
      <Header split={true}>
        <HeaderLeft>
          <Title>Link Library</Title>
        </HeaderLeft>
        <HeaderRight>
          <NewButton onClick={onNewLink}><Icons.PlusIcon size="s" /> New Link</NewButton>
        </HeaderRight>
      </Header>
      <Section size="l">
        <SectionTitle className="split">Active</SectionTitle>
        <LinkManageList
          header={true}
          links={links}
          onDelete={onDeleteLink}
          onEdit={onEditLink} 
          />
      </Section>
      <Section size="l">
        <SectionTitle className="split">Archived</SectionTitle>
        <LinkManageList
          header={true}
          links={deletedLinks}
          onRestore={onRestoreLink}/>
      </Section>
    </ContentCenter>
  </>)
}
export default LinksScreen